import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar/Sidebar';
import Navbar from '../components/common/Navbar/Navbar';
import AdminDashboard from '../pages/admin/AdminDashboard';
import Mentors from '../pages/admin/Mentors';
import Students from '../pages/admin/Students';
import Counsellors from '../pages/admin/Counsellors';
import Projects from '../pages/admin/Projects';
import Classes from '../pages/admin/Classes';
import Assignments from '../pages/admin/Assignments';
import BillOfMaterials from '../pages/admin/BillOfMaterials';
import Competitions from '../pages/admin/Competitions';
import CompetitionWorkflow from '../pages/admin/CompetitionWorkflow';
import CompetitionSetup from '../pages/common/CompetitionSetup';
import CompetitionMatcherAccess from '../pages/common/CompetitionMatcherAccess';
// Role-agnostic despite its path: the review endpoints are open to every
// competition admin, not just POC owners.
import CompetitionReviewQueue from '../pages/pocOwner/PocOwnerReviewQueue';
import Reports from '../pages/admin/Reports';
import AdminDisputes from '../pages/admin/AdminDisputes';
import ProjectDetails from '../pages/common/ProjectDetails';
import styles from './Routes.module.css';

const ManagerRoutes = () => {
  const menuItems = [
    { label: 'Dashboard', path: '/manager/dashboard', icon: 'dashboard' },
    { label: 'Mentors', path: '/manager/mentors', icon: 'mentors' },
    { label: 'Students', path: '/manager/students', icon: 'students' },
    { label: 'Counsellors', path: '/manager/counsellors', icon: 'counsellors' },
    { label: 'Projects', path: '/manager/projects', icon: 'projects' },
    { label: 'Classes', path: '/manager/classes', icon: 'classes' },
    { label: 'Assignments', path: '/manager/assignments', icon: 'assignments' },
    { label: 'Bill of Materials', path: '/manager/bom', icon: 'materials' },
    { label: 'Competition Matcher', path: '/manager/comp-matcher', icon: 'competitions' },
    { label: 'Competition Review', path: '/manager/comp-review', icon: 'assignments' },
    { label: 'Competitions', path: '/manager/competitions', icon: 'competitions' },
    { label: 'Competition Setup', path: '/manager/competition-setup', icon: 'materials' },
    { label: 'Journal Tracker', path: '/manager/competitions-legacy', icon: 'reports' },
    { label: 'Reports', path: '/manager/reports', icon: 'reports' },
    { label: 'Disputes', path: '/manager/disputes', icon: 'disputes' }
  ];

  return (
    <div className={styles.layout}>
      <Sidebar menuItems={menuItems} role="manager" />
      <div className={styles.mainContent}>
        <Navbar title="COSMIC Manager" />
        <div className={styles.content}>
          <Routes>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="mentors" element={<Mentors />} />
            <Route path="students" element={<Students />} />
            <Route path="counsellors" element={<Counsellors />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:projectId" element={<ProjectDetails />} />
            <Route path="classes" element={<Classes />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="bom" element={<BillOfMaterials />} />
            <Route path="comp-matcher" element={<CompetitionMatcherAccess />} />
            <Route path="comp-review" element={<CompetitionReviewQueue />} />
            <Route path="competitions" element={<CompetitionWorkflow />} />
            <Route path="competition-setup" element={<CompetitionSetup />} />
            <Route path="competitions-legacy" element={<Competitions />} />
            <Route path="reports" element={<Reports />} />
            <Route path="disputes" element={<AdminDisputes />} />
            <Route path="/" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default ManagerRoutes;

